import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import * as i2 from '@stg-js-ngx-core/oauth';
import { RbacService } from '@stg-js-ngx-core/oauth';
import { sortBy } from 'lodash';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeModule } from '@stg-js-ngx-core/tree-component';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@stg-js-ngx-core/oauth';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@stg-js-ngx-core/tree-component';
import * as ɵngcc5 from '@angular/forms';

const _c0 = ["hierarchyTree"];
const _c1 = ["selectButtonDropdown"];
const _c2 = ["dropdownButton"];
function HierarchyTreeComponent_div_0_button_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵtext(1, "Search \u00A0");
    ɵngcc0.ɵɵelement(2, "i", 23);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function HierarchyTreeComponent_div_0_div_14_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.filterDataString = $event; })("keyup", function HierarchyTreeComponent_div_0_div_14_Template_input_keyup_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.treeViewFilterChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.filterDataString);
} }
function HierarchyTreeComponent_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1, " Search requires a minimum of 3 characters. ");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtext(1, " No team data available to be displayed ");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_div_0_ng_template_19_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(node_r18.data[ctx_r19.hierarchyTreeOptions.displayField]);
} }
function HierarchyTreeComponent_div_0_ng_template_19_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 28);
} if (rf & 2) {
    const node_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", node_r18.data[ctx_r20.hierarchyTreeOptions.displayField], ɵngcc0.ɵɵsanitizeHtml);
} }
function HierarchyTreeComponent_div_0_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, HierarchyTreeComponent_div_0_ng_template_19_span_0_Template, 2, 1, "span", 14);
    ɵngcc0.ɵɵtemplate(1, HierarchyTreeComponent_div_0_ng_template_19_span_1_Template, 1, 1, "span", 27);
} if (rf & 2) {
    const node_r18 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngIf", !node_r18.data.showHTML);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r18.data.showHTML);
} }
function HierarchyTreeComponent_div_0_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "div", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_div_0_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "div", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "button", 3, 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵelement(5, "span", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7, 8);
    ɵngcc0.ɵɵlistener("click", function HierarchyTreeComponent_div_0_Template_div_click_6_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "div", 11);
    ɵngcc0.ɵɵelementStart(11, "span", 12);
    ɵngcc0.ɵɵtext(12, "Hierarchy ");
    ɵngcc0.ɵɵtemplate(13, HierarchyTreeComponent_div_0_button_13_Template, 3, 0, "button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, HierarchyTreeComponent_div_0_div_14_Template, 2, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(15, HierarchyTreeComponent_div_0_div_15_Template, 2, 0, "div", 15);
    ɵngcc0.ɵɵtemplate(16, HierarchyTreeComponent_div_0_div_16_Template, 2, 0, "div", 16);
    ɵngcc0.ɵɵelementStart(17, "tree-root", 17, 18);
    ɵngcc0.ɵɵlistener("activate", function HierarchyTreeComponent_div_0_Template_tree_root_activate_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.treeViewSelectionChange($event); })("loadNodeChildren", function HierarchyTreeComponent_div_0_Template_tree_root_loadNodeChildren_17_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.dataUpdated(); })("updateData", function HierarchyTreeComponent_div_0_Template_tree_root_updateData_17_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.dataModalUpdated(); })("toggleExpanded", function HierarchyTreeComponent_div_0_Template_tree_root_toggleExpanded_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.treeViewOnToggle($event); });
    ɵngcc0.ɵɵtemplate(19, HierarchyTreeComponent_div_0_ng_template_19_Template, 2, 2, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(21, HierarchyTreeComponent_div_0_ng_template_21_Template, 2, 0, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, HierarchyTreeComponent_div_0_div_23_Template, 2, 0, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.selectedTeamDisplayName || "Select Teams", " ");
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showSearchButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showSearch);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showSearch && ctx_r0.filterDataString && ctx_r0.filterDataString.length > 0 && ctx_r0.filterDataString.length < 3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showSearch && (!ctx_r0.treeData || ctx_r0.treeData && !ctx_r0.treeData.length));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.hierarchyId)("nodes", ctx_r0.treeData)("options", ctx_r0.hierarchyTreeOptions);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showLoading);
} }
function HierarchyTreeComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function HierarchyTreeComponent_ng_template_1_div_0_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.filterDataString = $event; })("keyup", function HierarchyTreeComponent_ng_template_1_div_0_Template_input_keyup_1_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.treeViewFilterChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r29.filterDataString);
} }
function HierarchyTreeComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1, " Search requires a minimum of 3 characters. ");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtext(1, " No team data available to be displayed ");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_ng_template_1_ng_template_5_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r41 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r42 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(node_r41.data[ctx_r42.hierarchyTreeOptions.displayField]);
} }
function HierarchyTreeComponent_ng_template_1_ng_template_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 28);
} if (rf & 2) {
    const node_r41 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r43 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", node_r41.data[ctx_r43.hierarchyTreeOptions.displayField], ɵngcc0.ɵɵsanitizeHtml);
} }
function HierarchyTreeComponent_ng_template_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, HierarchyTreeComponent_ng_template_1_ng_template_5_span_0_Template, 2, 1, "span", 14);
    ɵngcc0.ɵɵtemplate(1, HierarchyTreeComponent_ng_template_1_ng_template_5_span_1_Template, 1, 1, "span", 27);
} if (rf & 2) {
    const node_r41 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngIf", !node_r41.data.showHTML);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r41.data.showHTML);
} }
function HierarchyTreeComponent_ng_template_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "div", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_ng_template_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "div", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchyTreeComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵtemplate(0, HierarchyTreeComponent_ng_template_1_div_0_Template, 2, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(1, HierarchyTreeComponent_ng_template_1_div_1_Template, 2, 0, "div", 15);
    ɵngcc0.ɵɵtemplate(2, HierarchyTreeComponent_ng_template_1_div_2_Template, 2, 0, "div", 16);
    ɵngcc0.ɵɵelementStart(3, "tree-root", 17, 18);
    ɵngcc0.ɵɵlistener("activate", function HierarchyTreeComponent_ng_template_1_Template_tree_root_activate_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.treeViewSelectionChange($event); })("loadNodeChildren", function HierarchyTreeComponent_ng_template_1_Template_tree_root_loadNodeChildren_3_listener() { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.dataUpdated(); })("updateData", function HierarchyTreeComponent_ng_template_1_Template_tree_root_updateData_3_listener() { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r49 = ɵngcc0.ɵɵnextContext(); return ctx_r49.dataModalUpdated(); })("toggleExpanded", function HierarchyTreeComponent_ng_template_1_Template_tree_root_toggleExpanded_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ctx_r50.treeViewOnToggle($event); });
    ɵngcc0.ɵɵtemplate(5, HierarchyTreeComponent_ng_template_1_ng_template_5_Template, 2, 2, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(7, HierarchyTreeComponent_ng_template_1_ng_template_7_Template, 2, 0, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, HierarchyTreeComponent_ng_template_1_div_9_Template, 2, 0, "div", 21);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showSearch);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showSearch && ctx_r2.filterDataString && ctx_r2.filterDataString.length > 0 && ctx_r2.filterDataString.length < 3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showSearch && (!ctx_r2.treeData || ctx_r2.treeData && !ctx_r2.treeData.length));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r2.hierarchyId)("nodes", ctx_r2.treeData)("options", ctx_r2.hierarchyTreeOptions);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showLoading);
} }
const UrlSpace = {
    urls: {
        childrenForTeam: 'api/hierarchy/{teamName}/children/{sourceSystemId}',
        searchHierarchyWithRBAC: 'api/users/applications/{application}/roles/{role}/searchHierarchy_with_rbac/hierarchy_tree?limit={limit}&user_name={userName}&search={search}'
    }
};

class HierarchyTreeService {
    constructor(http, rbacService) {
        this.http = http;
        this.rbacService = rbacService;
    }
    getCurrentTeams(selectGlobalSelectedTeamByDefault, treeOptions, hideInactiveTeams) {
        let teams = this.formatTeamDataForHierarchyTree(this.rbacService.teams, treeOptions, hideInactiveTeams);
        if (selectGlobalSelectedTeamByDefault === true || selectGlobalSelectedTeamByDefault === 'true') {
            teams = this.selectCurrentTeam(teams);
        }
        return teams;
    }
    formatTeamDataForHierarchyTree(teams, treeOptions, hideInactive) {
        let orderedTeams = [];
        if (teams) {
            teams = JSON.parse(JSON.stringify(teams));
            for (let i = 0; i < teams.length; i++) {
                const team = this.processTeam(teams[i], treeOptions, hideInactive);
                if (team) {
                    orderedTeams.push(team);
                }
            }
        }
        return sortBy(orderedTeams, ['team_description']);
    }
    getChildrenForNode($scope, node, hideInActiveTeams) {
        let searchUrl, hierarchyType = 'standard', fetchChildrenEveryTime = $scope.fetchChildrenEveryTime;
        if (node) {
            let teamName = node.team_name, sourceSystemId = node.source_system_id, url = UrlSpace.urls.childrenForTeam.replace('{teamName}', teamName).replace('{sourceSystemId}', sourceSystemId);
            if ($scope.hierarchyType) {
                hierarchyType = $scope.hierarchyType;
            }
            searchUrl = { 'search': [{ 'property': 'hierarchy_type', 'value': hierarchyType, 'operator': 'in' }] };
            if ($scope.activeTeams) {
                searchUrl.search.push({ 'property': 'team_status_ind', 'value': 'A', 'operator': 'startsWith' });
            }
            url = url + '?search=' + JSON.stringify(searchUrl);
            if ($scope.liveOnApplication) {
                url = url + '&liveOnApplication=' + $scope.liveOnApplication;
            }
            //if the node doesn't current have any children the call API to load them
            if (fetchChildrenEveryTime === true || !node.children || (node.children && node.children.length === 0)) {
                return this.http.get(url).toPromise()
                    .then(res => {
                    return this.formatTeamDataForHierarchyTree(res, $scope.hierarchyTreeOptions, hideInActiveTeams);
                })
                    .catch(error => {
                    console.error(error);
                    return [];
                });
            }
            else {
                return Promise.resolve(node.children);
            }
        }
        else {
            return Promise.resolve([]);
        }
    }
    searchTeamsWithRBAC(textToSearch, operator, limit, $scope) {
        let applicationName = this.rbacService.rbacAppName, roleName = this.rbacService.currentRoleName, userName = this.rbacService.username, searchParams = [{ "property": "team_name", "value": textToSearch, "operator": operator }];
        if ($scope.liveOnApplication) {
            searchParams.push({ "property": "live_on_application", "value": $scope.liveOnApplication, "operator": "" });
        }
        if ($scope.searchHierarchyType) {
            searchParams.push({ "property": "hierarchy_type", "value": $scope.searchHierarchyType, "operator": "" });
        }
        else if ($scope.hierarchyType) {
            searchParams.push({ "property": "hierarchy_type", "value": $scope.hierarchyType, "operator": "" });
        }
        var search = { 'search': searchParams };
        var url = UrlSpace.urls.searchHierarchyWithRBAC
            .replace('{search}', JSON.stringify(search))
            .replace('{application}', applicationName)
            .replace('{role}', roleName)
            .replace('{userName}', userName)
            .replace('{limit}', limit);
        return this.http.get(url);
    }
    selectCurrentTeam(teams) {
        let selectedTeam = this.rbacService.selectedTeam;
        if (teams && selectedTeam) {
            for (let i = 0; i < teams.length; i++) {
                if (teams[i].team_name === selectedTeam.team_name) {
                    teams[i].selected = true;
                    break;
                }
            }
        }
        return teams;
    }
    processTeam(team, treeOptions, hideInactive) {
        if (hideInactive && team && team.team_status_ind && !team.team_status_ind.startsWith('A')) {
            return null;
        }
        let teamType = team.team_type_description || team.team_type_name || team.team_type || '';
        team[treeOptions.displayField] = team.team_description + ' (' + team.team_name + ')';
        team.children = team.children && team.children.length > 0 ? team.children : null;
        if (team.hasOwnProperty('adams_id')) {
            team[treeOptions.idField] = team.adams_id;
        }
        if (team.team_right && team.team_left) {
            team.hasChildren = team.team_right - team.team_left !== 1;
        }
        else if (teamType) {
            team.hasChildren = 'UNIT' !== teamType.toUpperCase() && 'HOSPITALSUNIT' !== teamType.toUpperCase();
        }
        else {
            team.hasChildren = !!(team.children && team.children.length);
        }
        if (team.children && team.children.length > 0) {
            team.children = this.formatTeamDataForHierarchyTree(team.children, treeOptions, hideInactive);
        }
        return team;
    }
}
HierarchyTreeService.ɵfac = function HierarchyTreeService_Factory(t) { return new (t || HierarchyTreeService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.RbacService)); };
HierarchyTreeService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HierarchyTreeService_Factory() { return new HierarchyTreeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.RbacService)); }, token: HierarchyTreeService, providedIn: "root" });
HierarchyTreeService.ctorParameters = () => [
    { type: HttpClient },
    { type: RbacService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HierarchyTreeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.RbacService }]; }, null); })();

const SEARCH_LIMITS = [{ value: 50 }, { value: 100 }, { value: 200 }, { value: 500 }];
const SEARCH_OPERATORS = [
    {
        name: 'Contains',
        operator: 'containsIgnoreCase'
    },
    {
        name: 'Starts With',
        operator: 'startsWithIgnoreCase'
    },
    {
        name: 'Exact match',
        operator: 'equalsIgnoreCase'
    }
];

class HierarchyTreeComponent {
    constructor(hierarchyTreeService, rbacService) {
        this.hierarchyTreeService = hierarchyTreeService;
        this.rbacService = rbacService;
        this.hierarchyId = 'hierarchyComponent';
        this.selectButton = false;
        this.showSearchButton = false;
        this.showSearch = false;
        this.hierarchyType = null;
        this.searchHierarchyType = null;
        this.activeTeams = false;
        this.liveOnApplication = null;
        this.hierarchyTreeOptions = {};
        this.selectGlobalSelectedTeamByDefault = false;
        this.syncGlobalTeamSelectionOnClose = false;
        this.fetchChildrenEveryTime = false;
        this.hideInactiveTeams = false;
        this.enableMultiSelect = false; //TODO
        this.disableTreeToggle = false; //TODO
        this.nodeSelected = new EventEmitter();
        this.disableSettings = false;
        this.showLoading = false;
        this.depthLevel = 0;
        this.searchLimit = SEARCH_LIMITS[0];
        this.searchOperator = SEARCH_OPERATORS[0];
    }
    ngOnInit() {
        this.hierarchyTreeOptions.idField = this.hierarchyTreeOptions.idField ? this.hierarchyTreeOptions.idField : 'id';
        this.hierarchyTreeOptions.displayField = this.hierarchyTreeOptions.displayField ? this.hierarchyTreeOptions.displayField : 'team_display_name';
        this.hierarchyTreeOptions.animateExpand = true;
        this.hierarchyTreeOptions.animateSpeed = 20;
        this.hierarchyTreeOptions.animateAcceleration = 1.5;
        this.hierarchyTreeOptions.getChildren = this.getChildren ? this.getChildData.bind(this) : this.getChildrenNodes.bind(this);
        this.treeData = JSON.parse(JSON.stringify(this.setInitialTree(this.setInitialTreeData)));
        if (this.selectedTeam) {
            this.selectedTeamDisplayName = this.selectedTeam.team_description + ' (' + this.selectedTeam.team_name + ')';
        }
        if (this.selectGlobalSelectedTeamByDefault) {
            this.selectedTeam = this.rbacService.selectedTeam;
            this.selectedTeamDisplayName = this.selectedTeam ? this.selectedTeam.team_description + ' (' + this.selectedTeam.team_name + ')' : 'No Teams Available';
        }
    }
    ngAfterViewInit() {
        if (this.treeData && this.expandToDepth) {
            this.depthLevel = this.expandToDepth;
            this.expand(this.treeData[0]);
        }
    }
    treeViewOnToggle(event) {
        // TODO remove children on close if fetchChildrenEverytime so that it will fetch the next time it expands
        // if (!event.isExpanded && event.node.data.hasChildren && this.fetchChildrenEveryTime){
        //
        // }
        // console.log(event);
        // console.log(this.treeData);
    }
    treeViewSelectionChange(event) {
        this.selectedTeam = event.node.data;
        this.selectedTeamDisplayName = this.selectedTeam ? this.selectedTeam.team_description + ' (' + this.selectedTeam.team_name + ')' : 'No Teams Available';
        this.handleSelectedTeams();
        this.nodeSelected.emit(event.node.data);
        if (this.selectButton && !this.enableMultiSelect) {
            this.selectButtonElement.nativeElement.click();
        }
    }
    setInitialTree(data) {
        if (data) {
            return this.hierarchyTreeService.formatTeamDataForHierarchyTree(data, this.hierarchyTreeOptions, this.hideInactiveTeams);
        }
        else {
            return this.hierarchyTreeService.getCurrentTeams(this.selectGlobalSelectedTeamByDefault, this.hierarchyTreeOptions, this.hideInactiveTeams);
        }
    }
    ;
    dataUpdated() {
        if (this.depthLevel !== 0 && this.expandToDepth) {
            let i = 0;
            let node = this.treeData;
            while (i < this.expandToDepth - this.depthLevel) {
                node = node[0].children;
                i++;
            }
            const elNode = this.tree.treeModel.getNodeById(node[0][this.hierarchyTreeOptions.idField]);
            elNode.expand();
            this.depthLevel -= 1;
        }
    }
    getChildData(node) {
        return this.getChildren(this, node);
    }
    getChildrenNodes(node) {
        return this.hierarchyTreeService.getChildrenForNode(this, node.data, this.hideInactiveTeams);
    }
    treeViewFilterChange() {
        this.treeDataResultCount = 0;
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }
        this.filterTimeout = setTimeout(() => {
            this.treeViewFilterChangeFunction();
        }, 500);
    }
    ;
    changeSearchLimit(limit) {
        this.searchLimit = limit;
        this.treeViewFilterChange();
    }
    ;
    changeSearchOperator(operator) {
        this.searchOperator = operator;
        this.treeViewFilterChange();
    }
    ;
    dataModalUpdated() {
        if (this.showSearch && this.filterDataString) {
            this.showLoading = true;
            this.tree.treeModel.expandAll();
            // short timer to expand all the children
            setTimeout(() => {
                this.showLoading = false;
            }, 500);
        }
    }
    handleSelectedTeams() {
        const currentTeamName = this.rbacService.selectedTeamName;
        const currentTeamSysId = this.rbacService.selectedTeam.source_system_id;
        if (this.syncGlobalTeamSelectionOnClose &&
            this.selectedTeam &&
            (!currentTeamName || !currentTeamSysId ||
                (currentTeamName && currentTeamSysId &&
                    (this.selectedTeam.team_name !== currentTeamName ||
                        this.selectedTeam.source_system_id.toString() !== currentTeamSysId.toString())))) {
            this.rbacService.switchSelectedTeam(this.selectedTeam);
        }
    }
    expand(node) {
        if (!node || this.depthLevel === 0) {
            return;
        }
        const elNode = this.tree.treeModel.getNodeById(node[this.hierarchyTreeOptions.idField]);
        elNode.expand();
        this.depthLevel = this.depthLevel - 1;
    }
    ;
    treeViewFilterChangeFunction() {
        if (this.searchDataObservable) {
            this.searchDataObservable.unsubscribe();
            this.showLoading = false;
        }
        if (this.filterDataString && this.filterDataString.length > 2) {
            this.showLoading = true;
            const textToSearch = this.filterDataString.replace(/</g, "&lt;").replace(/>/g, "&gt;"), operator = this.searchOperator.operator, limit = this.searchLimit.value;
            let sub;
            if (this.getSearchChildren) {
                sub = this.getSearchChildren(this, textToSearch);
            }
            else {
                sub = this.hierarchyTreeService.searchTeamsWithRBAC(textToSearch, operator, limit, this);
            }
            this.searchDataObservable = sub.subscribe((treeDataRes) => {
                if (treeDataRes && treeDataRes.metadata && treeDataRes.metadata.status !== 500) {
                    this.treeDataResultCount = treeDataRes.metadata.resultCount;
                    this.treeData = JSON.parse(JSON.stringify(this.hierarchyTreeService.formatTeamDataForHierarchyTree(treeDataRes.data, this.hierarchyTreeOptions, this.hideInactiveTeams)));
                    if (this.treeData && this.treeData.length) {
                        let regExp = new RegExp(textToSearch, 'i');
                        this.findAndReplace(this.treeData, regExp);
                    }
                }
                else {
                    console.error('An error occurred while searching text ' + textToSearch, treeDataRes);
                }
                this.showLoading = false;
            }, (error) => {
                this.showLoading = false;
                console.error('An error occurred while searching text ' + textToSearch, error);
            });
        }
        else if ((this.filterDataString && this.filterDataString.length === 0) || !this.filterDataString) {
            this.treeData = JSON.parse(JSON.stringify(this.setInitialTree(this.setInitialTreeData)));
            this.tree.treeModel.collapseAll();
        }
        else {
            // Do Nothing yet
        }
    }
    ;
    findAndReplace(treeData, regExp) {
        for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].hasOwnProperty(this.hierarchyTreeOptions.displayField) && treeData[i][this.hierarchyTreeOptions.displayField].search(regExp) > -1) {
                treeData[i].showHTML = true;
                treeData[i][this.hierarchyTreeOptions.displayField] = treeData[i][this.hierarchyTreeOptions.displayField].replace(regExp, '<span class="search-team-text-color">' + treeData[i][this.hierarchyTreeOptions.displayField].match(regExp)[0] + '</span>');
            }
            else {
                treeData[i].showHTML = false;
            }
            if (treeData[i].children && treeData[i].children.length) {
                this.findAndReplace(treeData[i].children, regExp);
            }
        }
    }
    ;
}
HierarchyTreeComponent.ɵfac = function HierarchyTreeComponent_Factory(t) { return new (t || HierarchyTreeComponent)(ɵngcc0.ɵɵdirectiveInject(HierarchyTreeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RbacService)); };
HierarchyTreeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HierarchyTreeComponent, selectors: [["app-hierarchy"]], viewQuery: function HierarchyTreeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
        ɵngcc0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tree = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectButtonDropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectButtonElement = _t.first);
    } }, inputs: { hierarchyId: "hierarchyId", selectButton: "selectButton", showSearchButton: "showSearchButton", showSearch: "showSearch", hierarchyType: "hierarchyType", searchHierarchyType: "searchHierarchyType", activeTeams: "activeTeams", liveOnApplication: "liveOnApplication", hierarchyTreeOptions: "hierarchyTreeOptions", selectGlobalSelectedTeamByDefault: "selectGlobalSelectedTeamByDefault", syncGlobalTeamSelectionOnClose: "syncGlobalTeamSelectionOnClose", fetchChildrenEveryTime: "fetchChildrenEveryTime", hideInactiveTeams: "hideInactiveTeams", enableMultiSelect: "enableMultiSelect", disableTreeToggle: "disableTreeToggle", disableSettings: "disableSettings", selectedTeam: "selectedTeam", expandToDepth: "expandToDepth", setInitialTreeData: "setInitialTreeData", getChildren: "getChildren", getSearchChildren: "getSearchChildren" }, outputs: { nodeSelected: "nodeSelected" }, decls: 3, vars: 2, consts: [["class", "dropdown", 4, "ngIf", "ngIfElse"], ["regularHierarchy", ""], [1, "dropdown"], ["type", "button", "id", "dropdownMenuButton", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "btn", "btn-outline-secondary", "dropdown-toggle", "form-control", "hierarchy-selection-button"], ["dropdownButton", ""], [1, "bs-caret"], [1, "caret"], ["aria-labelledby", "dropdownMenuButton", "role", "menu", 1, "dropdown-menu", "dropdown-menu-fit", "hierarchy-selection-dropdown", 3, "click"], ["selectButtonDropdown", ""], [1, "portlet", "light"], [1, "portlet-title"], [1, "caption"], [1, ""], ["class", "btn btn-default search-btn", 4, "ngIf"], [4, "ngIf"], ["class", "hierarchy-search-require-text", 4, "ngIf"], ["class", "no-data-found-hierarchy-tree", 4, "ngIf"], [3, "id", "nodes", "options", "activate", "loadNodeChildren", "updateData", "toggleExpanded"], ["hierarchyTree", ""], ["treeNodeTemplate", ""], ["loadingTemplate", ""], ["class", "hierarchy-loading-wrapper", 4, "ngIf"], [1, "btn", "btn-default", "search-btn"], [1, "fa", "fa-search"], ["name", "hierarchyFilter", "type", "text", "placeholder", "Search Hierarchy", 1, "hierarchial-search-input", 3, "ngModel", "ngModelChange", "keyup"], [1, "hierarchy-search-require-text"], [1, "no-data-found-hierarchy-tree"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "hierarchy-loading-wrapper"], [1, "loader"]], template: function HierarchyTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HierarchyTreeComponent_div_0_Template, 24, 9, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HierarchyTreeComponent_ng_template_1_Template, 10, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectButton)("ngIfElse", _r1);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.TreeComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], styles: ["@charset \"UTF-8\";  .search-team-text-color{color:orange!important}.hierarchy-selection-dropdown[_ngcontent-%COMP%]{padding:0 10px 5px;height:auto;max-height:400px;overflow-x:hidden;margin-top:0!important;min-width:280px;width:100%}.hierarchy-selection-dropdown[_ngcontent-%COMP%] > .portlet.light[_ngcontent-%COMP%]{padding:0 0 10px;margin-bottom:0!important;background-color:#fff}.hierarchy-selection-dropdown[_ngcontent-%COMP%]   .portlet[_ngcontent-%COMP%] > .portlet-title[_ngcontent-%COMP%]:after, .hierarchy-selection-dropdown[_ngcontent-%COMP%]   .portlet[_ngcontent-%COMP%] > .portlet-title[_ngcontent-%COMP%]:before{content:\" \";display:table}.hierarchy-selection-dropdown[_ngcontent-%COMP%]   .portlet[_ngcontent-%COMP%] > .portlet-title[_ngcontent-%COMP%]{padding:0;min-height:38px;color:#00a9a6!important;font-size:16px;text-transform:uppercase!important;font-weight:700!important;border-bottom:1px solid #eee;border-radius:4px 4px 0 0}.hierarchy-selection-dropdown[_ngcontent-%COMP%]   .portlet[_ngcontent-%COMP%] > .portlet-title[_ngcontent-%COMP%] > .caption[_ngcontent-%COMP%]{display:flex;font-size:18px;align-items:center}.hierarchy-selection-dropdown[_ngcontent-%COMP%]   .portlet[_ngcontent-%COMP%] > .portlet-title[_ngcontent-%COMP%] > .caption[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;padding:10px;align-items:center;flex-wrap:wrap}.hierarchy-selection-button[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;display:block;text-overflow:ellipsis;padding-right:25px;text-align:left}.hierarchy-selection-button[_ngcontent-%COMP%]   .bs-caret[_ngcontent-%COMP%]{position:absolute;right:10px}.hierarchy-selection-button[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%]:before{content:\"\\f107\";display:inline-block;border:0;font-family:\"Font Awesome 5 Pro\";font-style:normal;font-weight:400}.hierarchy-selection-button.btn.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.search-btn[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding-right:0}.hierarchial-search-input[_ngcontent-%COMP%]{padding-left:10px;border:none;outline:none!important;width:100%!important;margin:10px 25px 10px 0;padding-bottom:5px;border-bottom:1px solid #c5c5c5;border-radius:0;background-image:url(/ui/assets/images/magnify.png);background-repeat:no-repeat;background-position:98%;background-size:12px;height:30px}.hierarchial-search-input[_ngcontent-%COMP%]:focus{background-image:none!important}.hierarchy-cancel-icon[_ngcontent-%COMP%]{cursor:pointer;width:50px;text-align:center}.hierarchy-search-div[_ngcontent-%COMP%]{border-bottom-style:groove;width:97%;margin-left:16px;margin-top:6px;display:inline-flex;border-bottom-width:.1vh;border-bottom-color:#d3d3d3}.hierarchy-search-require-text[_ngcontent-%COMP%]{font-style:italic;padding-left:20px;padding-top:5px;font-size:12px;color:red}.no-data-found-hierarchy-tree[_ngcontent-%COMP%]{font-style:italic;padding-left:25px;padding-top:5px;position:fixed;color:#999;font-size:14px}.hierarchy-loading-wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background:#a9a9a961;z-index:999999;display:flex;align-items:center}.hierarchy-loading-wrapper[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{border:5px solid #f3f3f3;border-radius:50%;border-top:5px solid #3498db;width:50px;height:50px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}"] });
HierarchyTreeComponent.ctorParameters = () => [
    { type: HierarchyTreeService },
    { type: RbacService }
];
HierarchyTreeComponent.propDecorators = {
    hierarchyId: [{ type: Input }],
    selectButton: [{ type: Input }],
    showSearchButton: [{ type: Input }],
    showSearch: [{ type: Input }],
    expandToDepth: [{ type: Input }],
    hierarchyType: [{ type: Input }],
    searchHierarchyType: [{ type: Input }],
    activeTeams: [{ type: Input }],
    liveOnApplication: [{ type: Input }],
    hierarchyTreeOptions: [{ type: Input }],
    setInitialTreeData: [{ type: Input }],
    selectGlobalSelectedTeamByDefault: [{ type: Input }],
    syncGlobalTeamSelectionOnClose: [{ type: Input }],
    fetchChildrenEveryTime: [{ type: Input }],
    hideInactiveTeams: [{ type: Input }],
    enableMultiSelect: [{ type: Input }],
    disableTreeToggle: [{ type: Input }],
    getChildren: [{ type: Input }],
    getSearchChildren: [{ type: Input }],
    nodeSelected: [{ type: Output }],
    disableSettings: [{ type: Input }],
    selectedTeam: [{ type: Input }],
    tree: [{ type: ViewChild, args: ['hierarchyTree',] }],
    selectButtonDropdown: [{ type: ViewChild, args: ['selectButtonDropdown',] }],
    selectButtonElement: [{ type: ViewChild, args: ['dropdownButton',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HierarchyTreeComponent, [{
        type: Component,
        args: [{
                selector: 'app-hierarchy',
                template: "\r\n<div class=\"dropdown\" *ngIf=\"selectButton else regularHierarchy\">\r\n  <button class=\"btn btn-outline-secondary dropdown-toggle form-control hierarchy-selection-button\" #dropdownButton\r\n          type=\"button\" id=\"dropdownMenuButton\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\r\n    {{ selectedTeamDisplayName || 'Select Teams'}}\r\n    <span class=\"bs-caret\"><span class=\"caret\"></span></span>\r\n  </button>\r\n\r\n  <div class=\"dropdown-menu dropdown-menu-fit hierarchy-selection-dropdown\" #selectButtonDropdown aria-labelledby=\"dropdownMenuButton\" role=\"menu\" (click)=\"$event.stopPropagation()\">\r\n    <div class=\"portlet light\">\r\n      <div class=\"portlet-title\">\r\n        <div class=\"caption\">\r\n          <span class=\"\">Hierarchy\r\n            <button class=\"btn btn-default search-btn\" *ngIf=\"showSearchButton\">Search &nbsp;<i class=\"fa fa-search\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"showSearch\">\r\n      <input name=\"hierarchyFilter\" type=\"text\" [(ngModel)]=\"filterDataString\" class=\"hierarchial-search-input\" placeholder=\"Search Hierarchy\" (keyup)=\"treeViewFilterChange()\">\r\n    </div>\r\n\r\n    <!-- MIN CHARACTERS REQUIRED MESSAGE -->\r\n    <div class=\"hierarchy-search-require-text\" *ngIf=\"showSearch && filterDataString && filterDataString.length > 0 && filterDataString.length < 3\">\r\n      Search requires a minimum of 3 characters.\r\n    </div>\r\n\r\n    <!-- DATA NOT FOUND -->\r\n    <div class=\"no-data-found-hierarchy-tree\" *ngIf=\"showSearch && (!treeData || (treeData && !treeData.length))\">\r\n      No team data available to be displayed\r\n    </div>\r\n\r\n    <tree-root\r\n      #hierarchyTree\r\n      [id]=\"hierarchyId\"\r\n      [nodes]=\"treeData\"\r\n      [options]=\"hierarchyTreeOptions\"\r\n      (activate)=\"treeViewSelectionChange($event)\"\r\n      (loadNodeChildren)=\"dataUpdated()\"\r\n      (updateData)=\"dataModalUpdated()\"\r\n      (toggleExpanded)=\"treeViewOnToggle($event)\">\r\n      <ng-template #treeNodeTemplate let-node>\r\n        <span *ngIf=\"!node.data.showHTML\">{{ node.data[hierarchyTreeOptions.displayField] }}</span>\r\n        <span *ngIf=\"node.data.showHTML\" [innerHTML]=\"node.data[hierarchyTreeOptions.displayField]\"></span>\r\n      </ng-template>\r\n      <ng-template #loadingTemplate>\r\n        <div class=\"hierarchy-loading-wrapper\">\r\n          <div class=\"loader\">\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </tree-root>\r\n\r\n    <!-- LOADING MASK -->\r\n    <div class=\"hierarchy-loading-wrapper\"  *ngIf=\"showLoading\">\r\n      <div class=\"loader\">\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n<ng-template #regularHierarchy>\r\n  <div *ngIf=\"showSearch\">\r\n    <input name=\"hierarchyFilter\" type=\"text\" [(ngModel)]=\"filterDataString\" class=\"hierarchial-search-input\" placeholder=\"Search Hierarchy\" (keyup)=\"treeViewFilterChange()\">\r\n  </div>\r\n\r\n  <!-- MIN CHARACTERS REQUIRED MESSAGE -->\r\n  <div class=\"hierarchy-search-require-text\" *ngIf=\"showSearch && filterDataString && filterDataString.length > 0 && filterDataString.length < 3\">\r\n    Search requires a minimum of 3 characters.\r\n  </div>\r\n\r\n  <!-- DATA NOT FOUND -->\r\n  <div class=\"no-data-found-hierarchy-tree\" *ngIf=\"showSearch && (!treeData || (treeData && !treeData.length))\">\r\n    No team data available to be displayed\r\n  </div>\r\n\r\n  <tree-root\r\n    #hierarchyTree\r\n    [id]=\"hierarchyId\"\r\n    [nodes]=\"treeData\"\r\n    [options]=\"hierarchyTreeOptions\"\r\n    (activate)=\"treeViewSelectionChange($event)\"\r\n    (loadNodeChildren)=\"dataUpdated()\"\r\n    (updateData)=\"dataModalUpdated()\"\r\n    (toggleExpanded)=\"treeViewOnToggle($event)\">\r\n    <ng-template #treeNodeTemplate let-node>\r\n      <span *ngIf=\"!node.data.showHTML\">{{ node.data[hierarchyTreeOptions.displayField] }}</span>\r\n      <span *ngIf=\"node.data.showHTML\" [innerHTML]=\"node.data[hierarchyTreeOptions.displayField]\"></span>\r\n    </ng-template>\r\n    <ng-template #loadingTemplate>\r\n      <div class=\"hierarchy-loading-wrapper\">\r\n        <div class=\"loader\">\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n  </tree-root>\r\n\r\n\r\n  <!-- LOADING MASK -->\r\n  <div class=\"hierarchy-loading-wrapper\"  *ngIf=\"showLoading\">\r\n    <div class=\"loader\">\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: ["@charset \"UTF-8\";::ng-deep .search-team-text-color{color:orange!important}.hierarchy-selection-dropdown{padding:0 10px 5px;height:auto;max-height:400px;overflow-x:hidden;margin-top:0!important;min-width:280px;width:100%}.hierarchy-selection-dropdown>.portlet.light{padding:0 0 10px;margin-bottom:0!important;background-color:#fff}.hierarchy-selection-dropdown .portlet>.portlet-title:after,.hierarchy-selection-dropdown .portlet>.portlet-title:before{content:\" \";display:table}.hierarchy-selection-dropdown .portlet>.portlet-title{padding:0;min-height:38px;color:#00a9a6!important;font-size:16px;text-transform:uppercase!important;font-weight:700!important;border-bottom:1px solid #eee;border-radius:4px 4px 0 0}.hierarchy-selection-dropdown .portlet>.portlet-title>.caption{display:flex;font-size:18px;align-items:center}.hierarchy-selection-dropdown .portlet>.portlet-title>.caption span{width:100%;display:flex;justify-content:space-between;padding:10px;align-items:center;flex-wrap:wrap}.hierarchy-selection-button{overflow:hidden;white-space:nowrap;display:block;text-overflow:ellipsis;padding-right:25px;text-align:left}.hierarchy-selection-button .bs-caret{position:absolute;right:10px}.hierarchy-selection-button .caret:before{content:\"\\f107\";display:inline-block;border:0;font-family:\"Font Awesome 5 Pro\";font-style:normal;font-weight:400}.hierarchy-selection-button.btn.dropdown-toggle:after{display:none}.search-btn i{padding-right:0}.hierarchial-search-input{padding-left:10px;border:none;outline:none!important;width:100%!important;margin:10px 25px 10px 0;padding-bottom:5px;border-bottom:1px solid #c5c5c5;border-radius:0;background-image:url(/ui/assets/images/magnify.png);background-repeat:no-repeat;background-position:98%;background-size:12px;height:30px}.hierarchial-search-input:focus{background-image:none!important}.hierarchy-cancel-icon{cursor:pointer;width:50px;text-align:center}.hierarchy-search-div{border-bottom-style:groove;width:97%;margin-left:16px;margin-top:6px;display:inline-flex;border-bottom-width:.1vh;border-bottom-color:#d3d3d3}.hierarchy-search-require-text{font-style:italic;padding-left:20px;padding-top:5px;font-size:12px;color:red}.no-data-found-hierarchy-tree{font-style:italic;padding-left:25px;padding-top:5px;position:fixed;color:#999;font-size:14px}.hierarchy-loading-wrapper{position:absolute;top:0;left:0;width:100%;height:100%;background:#a9a9a961;z-index:999999;display:flex;align-items:center}.hierarchy-loading-wrapper .loader{border:5px solid #f3f3f3;border-radius:50%;border-top:5px solid #3498db;width:50px;height:50px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"]
            }]
    }], function () { return [{ type: HierarchyTreeService }, { type: ɵngcc2.RbacService }]; }, { hierarchyId: [{
            type: Input
        }], selectButton: [{
            type: Input
        }], showSearchButton: [{
            type: Input
        }], showSearch: [{
            type: Input
        }], hierarchyType: [{
            type: Input
        }], searchHierarchyType: [{
            type: Input
        }], activeTeams: [{
            type: Input
        }], liveOnApplication: [{
            type: Input
        }], hierarchyTreeOptions: [{
            type: Input
        }], selectGlobalSelectedTeamByDefault: [{
            type: Input
        }], syncGlobalTeamSelectionOnClose: [{
            type: Input
        }], fetchChildrenEveryTime: [{
            type: Input
        }], hideInactiveTeams: [{
            type: Input
        }], enableMultiSelect: [{
            type: Input
        }], disableTreeToggle: [{
            type: Input
        }], nodeSelected: [{
            type: Output
        }], disableSettings: [{
            type: Input
        }], selectedTeam: [{
            type: Input
        }], expandToDepth: [{
            type: Input
        }], setInitialTreeData: [{
            type: Input
        }], getChildren: [{
            type: Input
        }], getSearchChildren: [{
            type: Input
        }], tree: [{
            type: ViewChild,
            args: ['hierarchyTree']
        }], selectButtonDropdown: [{
            type: ViewChild,
            args: ['selectButtonDropdown']
        }], selectButtonElement: [{
            type: ViewChild,
            args: ['dropdownButton']
        }] }); })();

class HierarchyTreeModule {
}
HierarchyTreeModule.ɵfac = function HierarchyTreeModule_Factory(t) { return new (t || HierarchyTreeModule)(); };
HierarchyTreeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HierarchyTreeModule });
HierarchyTreeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TreeModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HierarchyTreeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HierarchyTreeComponent
                ],
                exports: [
                    HierarchyTreeComponent
                ],
                imports: [
                    CommonModule,
                    TreeModule,
                    FormsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HierarchyTreeModule, { declarations: function () { return [HierarchyTreeComponent]; }, imports: function () { return [CommonModule,
        TreeModule,
        FormsModule]; }, exports: function () { return [HierarchyTreeComponent]; } }); })();

/*
 * Public API Surface of hierarchy-tree
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HierarchyTreeComponent, HierarchyTreeModule, HierarchyTreeService };

